import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function checkout(cmd) {
  return dispatchCommand("Checkout", cmd); 
}
